<template>
<b-row class="background no-gutters">

    <b-col class="tool-border" cols="12">
        <popupModal v-if="userData.isWhatTed || userData.isEnvironment || userData.isGenetics  || userData.isGender"></popupModal>
        <tedtfHeader :image="'background'" :screenTitle="'Background'"></tedtfHeader>
        <b-col class="page-background-gradient reduce-padding" cols="12">
            <b-row class="page-content no-gutters">
                <div class="body-sec">


                    <b-col class="reduce-padding" cols="12">
                        <div class="main-text">
                            <p class="flare-text">Autoimmune diseases like TED can sometimes “flare.” There are 3 common causes, or triggers, for autoimmune diseases and flares.<br>Click on each icon to learn more.</p>
                        </div>
                    </b-col>

                    <b-row class="Environment no-gutters">

                        <b-row class="image-div no-gutters">
                            <div class="environment-image" @click="showAlert('env');tagNav('Infections/Environment Icon','background');"></div>
                        </b-row>
                        <b-row class="text-div">
                            <div class="Environment-text " @click="showAlert('env');tagNav('Infections/Environment Link','background');">Infections/Environment </div>
                            <div class="list-text">
                                <ul>
                                    <li>Viral infections can trigger a flare of an underlying autoimmune condition
                                        that was previously in remission <b>(this is a major cause for flares).</b></li>
                                    <li class="Vaccines-padding">A woman's immune system tends to have a stronger response to infections, which can sometimes cause a flare.</li>

                                </ul>
                            </div>
                        </b-row>
                    </b-row>

                    <b-row class="Genetic no-gutters">
                        <b-row class="image-div no-gutters">
                            <div class="genetic-image" @click="showAlert('genetic');tagNav('Genetics Icon','background');"></div>
                        </b-row>
                        <b-row class="text-div gen-text">
                            <div class="Genetic-heading " @click="showAlert('genetic');tagNav('Genetics Link','background');">Genetics</div>
                            <p class="genetic-text">Women are more than 2x as likely to have TED than men. In a study, women had 3x more TED flares.<sup>*</sup></p>
                        </b-row>
                    </b-row>
                    <b-row class="Gender no-gutters">
                        <b-row class="image-div no-gutters">
                            <div class="gender-image" @click="showAlert('gender');tagNav('Gender Hormones/Pregnancy Icon','background');"></div>
                        </b-row>
                        <b-row class="text-div">
                            <div class="Gender-heading " @click="showAlert('gender');tagNav('Gender Hormones/Pregnancy Link','background');">Gender Hormones/Pregnancy</div>
                            <p class="gender-text"> TED flares have occurred in women during pregnancy due to hormone changes.</p>
                        </b-row>
                    </b-row>
                    
                    <b-row class="note no-gutters">
                        <b-col class="reduce-padding" cols="12">
                            <div class="note-text"><sup>*</sup>A review of 193 patients for reactivation from 1996 to 2001.</div>
                        </b-col>
                    </b-row>


                </div>
            </b-row>
        </b-col>

        <tedftNavigation v-bind:navButtons="['next','back', 'showMidCol']" :currentScreen="2" :isSymptom="true" :isHideMenu="false" :isShowTedBtn="true"></tedftNavigation>
    </b-col>

</b-row>
</template>
<script>
    /* eslint-disable */
    import { mapGetters } from 'vuex';
import taggingMixin from "../mixins/taggingMixin";
    import tedtfHeader from '../components/tedtfHeader.vue';
    import tedftNavigation from '../components/tedftNavigation.vue';
    import popupModal from '@/components/popupModal.vue';

    export default {
        name: "BackgroundPage",
        mixins: [taggingMixin],
        mounted: function() {
            // this.userData.isNextSteps = false;
            // this.userData.selectedSyptom = '';
        },
        components: {
            'tedtfHeader': tedtfHeader,
            'tedftNavigation': tedftNavigation,
            'popupModal': popupModal
        },

        computed: {
            ...mapGetters('userData', ['userData'])
        },

        methods: {
          
            showAlert(type) {
                if (type == 'env')
                    this.userData.isEnvironment = true;

                else if (type == 'genetic')
                    this.userData.isGenetics = true;

                else if (type == 'gender')
                    this.userData.isGender = true;

            }


        },

        data() {
            return {};
        },
    };
</script>


<style lang="scss" scoped>
</style>
